import { Component, OnInit } from '@angular/core';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatasourceConnectionComponent } from '../../datasource-connection/datasource-connection.component';
import { ClientService } from '../../../services/client.service';

@Component({
  selector: 'app-pubmatic',
  templateUrl: './pubmatic.component.html',
  styleUrls: ['./pubmatic.component.scss']
})
export class PubmaticComponent extends BaseDatasourceComponent implements OnInit {
  step = 1;
  organizations: { id: string; name: string }[] = [];
  selectedOrganizationIds: FormControl;
  loading = false;
  verificationStatus: 'success' | 'failed' | null = null;

  constructor(
    private client: ClientService,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<DatasourceConnectionComponent>) {
    super();
  }

  ngOnInit() {
    this.connectionForm = new FormGroup({
      username: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required]),
    });
    this.selectedOrganizationIds = new FormControl([], [Validators.required]);
  }

  async fetchOrganizations() {
    this.organizations = [];
    this.selectedOrganizationIds.reset([]);

    if (!this.connectionForm.valid) {
      this.openSnackBarWarning(this.snackBar, 'Please fill in all required fields', 'closed');
      return;
    }
    this.loading = true;
    this.verificationStatus = null;
    const { username, password } = this.connectionForm.value;
    try {
      const result = await this.client.account.fetchTokenAndOrganization({ username, password });
      this.organizations = result as { id: string; name: string }[];
      this.verificationStatus = 'success';
      this.step = 2;
    } catch (e) {
      this.verificationStatus = 'failed';
      this.openSnackBarWarning(this.snackBar, e?.error?.message || e?.message || 'Failed to fetch organizations', 'closed');
    } finally {
      this.loading = false;
    }
  }

  connect() {
    if (!this.selectedOrganizationIds.valid) {
      this.openSnackBarWarning(this.snackBar, 'Please select an organization', 'closed');
      return;
    }
    this.loading = true;
    this.client.account.savePubmaticConfig({ organizationIds: this.selectedOrganizationIds.value.map((id: number | string) => id + '') }).then(() => {
      this.loading = false;
      this.openSnackBar(this.snackBar, 'Data source connected.', 'closed');
      this.dialogRef.close();
    }).catch(e => {
      this.loading = false;
      this.openSnackBarWarning(this.snackBar, e.message, 'closed');
      this.dialogRef.close();
    });
  }
}
